import metaTags from "./metaTags";

type tagType = (typeof metaTags)[0];

export const getTags = (location?: string): tagType | undefined => {
  const tag = metaTags.find((tag) => {
    return tag.Page === location;
  });

  return tag;
};

export const faqs = [
  {
    link: "/services/house-cleaning",
    questions: [
      {
        question: "How long will my cleaning take?",
        answer:
          "The cleaning process is various and can be checked at check-out."
      },
      {
        question: "Is your cleaning methods safe for children and pets?",
        answer: "We only use eco-friendly products, which are safe for all."
      }
    ]
  },

  {
    link: "/services/Kitchen",
    questions: [
      {
        question: "What is a kitchen cleaning service?",
        answer:
          "Our kitchen deep clean bundle includes a thorough cleaning of all kitchen appliances."
      },
      {
        question: "Why should I hire a kitchen cleaning service?",
        answer:
          "Saving time and getting a more thorough deep clean of the kitchen."
      }
    ]
  },

  {
    link: "/services/oven-kitchen-cleaning",
    questions: [
      {
        question: "Why is it important to clean my oven regularly?",
        answer:
          "If the oven is left uncleaned, it can lead to smoke or bad odors."
      },
      {
        question: "What are the signs that my oven needs cleaning?",
        answer: "Stuck food, smoke and bad odors after cooking."
      }
    ]
  },

  {
    link: "/services/bathroom-cleaning",
    questions: [
      {
        question: "Why should I hire a professional bathroom cleaning service?",
        answer:
          "We provide steam cleaning to reach unreachable spots and remove 99.9% of bacteria."
      },
      {
        question: "How long does it take to clean a bathroom professionally?",
        answer: "It will roughly take from 1-3 hours."
      }
    ]
  },
  {
    link: "/services/upholstery-cleaning",
    questions: [
      {
        question: "What is upholstery cleaning?",
        answer:
          "Upholstery cleaning is the process of cleaning the fabric on furniture or carpets using a special cleaner or detergent."
      },
      {
        question: "Can professional upholstery cleaners remove all stains?",
        answer:
          "Most of the time yes, but if the stain is left for 5+ years, it might not come off."
      }
    ]
  },

  {
    link: "/services/carpet-floor-cleaning",
    questions: [
      {
        question: "How often should I have my carpets professionally cleaned?",
        answer: "At least once a year."
      },
      {
        question: "What methods are used for carpet cleaning?",
        answer:
          "Vacumming, shampooing, and dry suctioning to take out the water left."
      }
    ]
  },

  {
    link: "/services/window-cleaning",
    questions: [
      {
        question: "Why should I hire a professional window cleaning service?",
        answer: "Save time and have better results."
      },
      {
        question:
          "How long will my windows stay clean after a professional cleaning?",
        answer: "4-6 weeks after the cleaning process."
      }
    ]
  },

  {
    link: "/services/powerwashing-services",
    questions: [
      {
        question: "What is power washing?",
        answer:
          "Powerwashing is to remove any dirt, grime, weeds, algae, and mud from an outside surface, transforming it to brand new."
      },
      {
        question:
          "What is the difference between power washing and pressure washing?",
        answer:
          "Power washing uses soap and hot water; pressure washing uses cold water."
      }
    ]
  },

  {
    link: "/services/Chimney-Cleaning",
    questions: [
      {
        question: "Why is chimney cleaning important?",
        answer:
          "A clean chimney means a safer, more efficient fireplace and home heating appliance."
      },
      {
        question: "How often should I have my chimney cleaned?",
        answer: "At least once a year."
      }
    ]
  },

  {
    link: "/services/Mould_walls",
    questions: [
      {
        question: "What is mould treatment?",
        answer:
          "Using industrial-based chemicals, we completely kill away the mould present."
      },
      {
        question: "How do I know if I have mould in my home?",
        answer: "Black spots and damp smell."
      }
    ]
  },

  {
    link: "/services/Airbnb_Office",
    questions: [
      {
        question: "What does a typical office cleaning service include?",
        answer:
          "Office cleaning includes maintaining a clean and healthy environment."
      },
      {
        question: "Why should I hire a professional office cleaning service?",
        answer:
          "Our office cleaning is very comfortable for every office personal, because we include VAT and no contracts are needed to hire cleaners."
      }
    ]
  },

  {
    link: "/services/Afterrenovationcleaning",
    questions: [
      {
        question: "How long does after renovation cleaning take?",
        answer: "Cleaning one room would take approximately one hour."
      },
      {
        question: "What does after renovation cleaning typically include?",
        answer:
          "A room may appear pristine and refreshed, but often there is a layer of dust, debris, and residue left behind that requires thorough cleaning."
      }
    ]
  },

  {
    link: "/services/handyman-service",
    questions: [
      {
        question: "Do I need to provide my own materials for the job?",
        answer:
          "The best choice is to provide your own materials so you know exactly what you are getting put in or fixed."
      },
      {
        question: "How do I schedule a handyman service?",
        answer:
          "The best way to schedule a handyman is online or via email at hello@cleanbee.ie."
      }
    ]
  },

  {
    link: "/services/Painting",
    questions: [
      {
        question: "Why should I hire a professional for wall painting?",
        answer: "Professional painters ensure a high-standard painting service."
      },
      {
        question: "How do I prepare my walls for painting?",
        answer:
          "Some walls don't need to be prepared. If you are unsure if you need to prepare a wall for painting, get in contact with us via email at hello@cleanbee.ie."
      }
    ]
  },

  {
    link: "/services/Car_Cleaning",
    questions: [
      {
        question: "What types of car cleaning services are available?",
        answer: "Regular-sized cars (5 seaters) and Jeep cars (7 seaters)."
      },
      {
        question:
          "What is the difference between car washing and car detailing?",
        answer: "Car washing is only to touch up the car"
      }
    ]
  }
];
